import type {
  CreateLeaveRequest,
  Leave,
  LeaveListResponse,
  LeaveQuery,
  MeResponse,
  UpdateLeaveRequest,
} from '@lemoment/shared';

import { apiClient } from '../../../core';

const toQueryString = (query: LeaveQuery): string => {
  const params = new URLSearchParams();
  if (query.crewId) {
    params.set('crewId', query.crewId);
  }
  if (query.from) {
    params.set('from', query.from);
  }
  if (query.to) {
    params.set('to', query.to);
  }
  const qs = params.toString();
  return qs ? `?${qs}` : '';
};

export const getMe = (): Promise<MeResponse> => apiClient.get('/me');

export const getLeaves = (query: LeaveQuery = {}): Promise<LeaveListResponse> =>
  apiClient.get(`/leaves${toQueryString(query)}`);

/** Whole-team active leaves overlapping the range — powers the team calendar. */
export const getTeamLeaves = (query: {
  from: string;
  to: string;
}): Promise<LeaveListResponse> =>
  apiClient.get(`/team/leaves?from=${query.from}&to=${query.to}`);

export const createLeave = (body: CreateLeaveRequest): Promise<Leave> =>
  apiClient.post('/leaves', body);

export const updateLeave = (
  id: string,
  body: UpdateLeaveRequest,
): Promise<Leave> => apiClient.patch(`/leaves/${id}`, body);

export const cancelLeave = (id: string): Promise<Leave> =>
  apiClient.del(`/leaves/${id}`);
